import React from "react";
import { monthList } from "./eaImportApi";

const Row = ({ label, children, testid }) => (
  <div className="flex gap-2 text-xs py-0.5" data-testid={testid}>
    <span className="text-slate-500 w-44 flex-shrink-0">{label}</span>
    <span className="text-slate-800">{children}</span>
  </div>
);

const fmtN = (v, d = 0) => (v == null ? "—" : Number(v).toLocaleString("it-IT", { maximumFractionDigits: d }));

export const EaImportResult = ({ job }) => {
  const d = job.detected || {};
  const r = job.result || {};
  const pun = r.pun || {};
  return (
    <div className="mt-3 grid grid-cols-1 lg:grid-cols-2 gap-x-6 rounded-xl bg-slate-50 border border-slate-200 p-3" data-testid={`ea-result-${job.id}`}>
      <div>
        <Row label="Cliente">{job.company_name || "—"}</Row>
        <Row label="Commodity">{d.commodity === "POWER" ? "Power" : d.commodity === "GAS" ? "Gas" : "—"}</Row>
        {d.pod && <Row label="POD">{d.pod}</Row>}
        {d.pdr && <Row label="PDR">{d.pdr}</Row>}
        {d.remi && <Row label="REMI">{d.remi}{d.identifier_type === "REMI" ? " (allaccio diretto trasporto)" : ""}</Row>}
        <Row label="Anno">{d.year}</Row>
        <Row label="Mesi consuntivi / previsionali">{monthList(d.months_actual)} · {monthList(d.months_forecast)}</Row>
        <Row label="Fatture disponibili">{monthList(r.invoices_available)}</Row>
        <Row label="Fatture non disponibili">{monthList(r.invoices_not_available)}</Row>
      </div>
      <div>
        <Row label={r.is_update ? "Mesi modificati" : "Mesi importati"}>{monthList(r.months_updated)} {r.is_update && `(${r.changes_count} variazioni)`}</Row>
        <Row label="Record">
          {fmtN(r.records?.months)} mesi · {fmtN(r.records?.costs)} costi · {fmtN(r.records?.hedges)} fixing · {fmtN(r.records?.quarter_days_snapshot)} giorni 15 min
        </Row>
        {d.commodity === "POWER" && (
          <Row label="PUN">
            {pun.days_imported ? `${fmtN(pun.days_imported)} giorni importati` : "nessun giorno nuovo"} · {fmtN(pun.days_already_present)} già presenti
          </Row>
        )}
        <Row label="Ricostruzione Adybo">{d.has_adybo_reconstruction ? "presente" : "assente (solo dati)"}</Row>
        <Row label="Portfolio Management">{d.has_portfolio_management ? "rilevato" : "non presente"}</Row>
        <Row label="File temporaneo">{job.temp_file_deleted ? "eliminato" : "—"}</Row>
      </div>
    </div>
  );
};

export default EaImportResult;
